import React from 'react';
import { components } from 'react-select';
import { useStyles } from './OptionWithDescription.styles';
export function OptionWithDescription(props) {
    var _a;
    const classes = useStyles();
    return (React.createElement(components.Option, Object.assign({}, props),
        React.createElement("div", { className: classes.container },
            React.createElement("div", { className: classes.label }, props.children),
            React.createElement("div", { className: classes.description }, (_a = props.data) === null || _a === void 0 ? void 0 : _a.description))));
}
//# sourceMappingURL=OptionWithDescription.js.map